import { useNavigation } from "@react-navigation/native";
import { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { usePolling } from "../../../common/usePolling";
import { hideLoader } from "../../../commonComponents/Loader/loader.actions";
import { Network } from "../../../utils/network";
import { onMetaStatusHandling } from "../childComponents/addMoneyUtils";
import { ON_META_STATUS_PASS } from "../wallet.constant";

export function useMetaHandling(
  onMetaPaymentConfig,
  setOnMetaPaymentConfig,
  amount
) {
  const navigation = useNavigation();
  const timer = useRef(0);
  const dispatch = useDispatch();
  const fetchOnMetaOrderStatus = async () => {
    const res = await Network.fetchOnMetaOrderStatus(
      onMetaPaymentConfig?.orderIdDetails
    );
    timer.current = timer.current + 3000;
    if (
      timer.current > 12000 ||
      ON_META_STATUS_PASS.includes(res?.data?.status)
    ) {
      setOnMetaPaymentConfig({
        upiOption: [],
        isShowPaymentOptions: false,
        orderIdDetails: null,
        startPolling: false,
      });
      timer.current = 0;
      dispatch(hideLoader());
      onMetaStatusHandling(res?.data?.status, amount, navigation);
    }
  };

  usePolling(
    () => {
      fetchOnMetaOrderStatus();
    },
    3000,
    onMetaPaymentConfig?.startPolling
  );
}
